import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import CourseListing from './pages/CourseListing';
import CoursePage from './pages/CoursePage';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Pricing from './pages/PricingPage';
import Login from './pages/Login';
import Signup from './pages/Signup';

function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<CourseListing />} />
          <Route path="/workout/:id" element={<CoursePage />} />
          <Route path="/plan" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
